export const USER_HISTORY_PAYMENT = 'USER_HISTORY_PAYMENT';
export const USER_HISTORY_PAYMENT_SUCCESS = 'USER_HISTORY_PAYMENT_SUCCESS';
export const USER_HISTORY_PAYMENT_FAIL = 'USER_HISTORY_PAYMENT_FAIL';

export const GET_REQUEST_PAYMENT_SILA = 'GET_REQUEST_PAYMENT_SILA';
export const GET_REQUEST_PAYMENT_SILA_SUCCESS =
  'GET_REQUEST_PAYMENT_SILA_SUCCESS';
export const GET_REQUEST_PAYMENT_SILA_FAIL = 'GET_REQUEST_PAYMENT_SILA_FAIL';

export const DECLINE_REQUEST_PAYMENT_SILA = 'DECLINE_REQUEST_PAYMENT_SILA';
export const DECLINE_REQUEST_PAYMENT_SILA_SUCCESS =
  'DECLINE_REQUEST_PAYMENT_SILA_SUCCESS';
export const DECLINE_REQUEST_PAYMENT_SILA_FAIL =
  'DECLINE_REQUEST_PAYMENT_SILA_FAIL';

export const ADD_MANUAL_BANK_CARD = 'ADD_MANUAL_BANK_CARD';
export const ADD_MANUAL_BANK_CARD_SUCCESS = 'ADD_MANUAL_BANK_CARD_SUCCESS';
export const ADD_MANUAL_BANK_CARD_FAIL = 'ADD_MANUAL_BANK_CARD_FAIL';

export const GET_FILE_TRANSACTION_PDF = 'GET_FILE_TRANSACTION_PDF';
export const GET_FILE_TRANSACTION_PDF_SUCCESS =
  'GET_FILE_TRANSACTION_PDF_SUCCESS';
export const GET_FILE_TRANSACTION_PDF_FAIL = 'GET_FILE_TRANSACTION_PDF_FAIL';

export const SEND_NEED_HELP = 'SEND_NEED_HELP';
export const SEND_NEED_HELP_SUCCESS = 'SEND_NEED_HELP_SUCCESS';
export const SEND_NEED_HELP_FAIL = 'SEND_NEED_HELP_FAIL';

export const DOWNLOAD_HISTORY_TRANSACTION_PDF =
  'DOWNLOAD_HISTORY_TRANSACTION_PDF';
export const DOWNLOAD_HISTORY_TRANSACTION_PDF_SUCCESS =
  'DOWNLOAD_HISTORY_TRANSACTION_PDF_SUCCESS';
export const DOWNLOAD_HISTORY_TRANSACTION_PDF_FAIL =
  'DOWNLOAD_HISTORY_TRANSACTION_PDF_FAIL';

export const DOWNLOAD_HISTORY_TRANSACTION_CSV =
  'DOWNLOAD_HISTORY_TRANSACTION_CSV';
export const DOWNLOAD_HISTORY_TRANSACTION_CSV_SUCCESS =
  'DOWNLOAD_HISTORY_TRANSACTION_CSV_SUCCESS';
export const DOWNLOAD_HISTORY_TRANSACTION_CSV_FAIL =
  'DOWNLOAD_HISTORY_TRANSACTION_CSV_FAIL';
